import { useEffect } from 'react'
import { useCookieConsent } from 'react-cookie-manager'

declare global {
  interface Window {
    fbAsyncInit?: () => void
    FB?: any
  }
}

export function FacebookSDKLoader () {
  const { detailedConsent } = useCookieConsent()

  useEffect(() => {
    if (detailedConsent?.Social.consented && !window.FB) {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: '859268305771217',
          cookie: true,
          xfbml: true,
          version: 'v20.0'
        })
      }
      const script = document.createElement('script')
      script.src = 'https://connect.facebook.net/en_US/sdk.js'
      script.async = true
      script.defer = true
      script.crossOrigin = 'anonymous'
      document.body.appendChild(script)
    }
  }, [detailedConsent?.Social.consented])

  return null
}
